const initialState = {
    umpSupply: 0,
    ballSupply: 180,
    user: {
      email: '',
      isLoggedIn: false
    }
  };
  
  const gameDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'UPDATE_UMP_SUPPLY':
        return { ...state, umpSupply: action.payload };
      case 'UPDATE_BALL_SUPPLY':
        return { ...state, ballSupply: action.payload };
      case 'SET_USER':
        return { ...state, user: { email: action.payload, isLoggedIn: true } };
      case 'LOGOUT':
        return { ...state, user: { ...state.user, isLoggedIn: false } };
      case 'LOGIN':
        return { ...state, user: { ...state.user, isLoggedIn: true } };
      default:
        return state;
    }
  };
  
  export default gameDetailsReducer;